import React, { useState, useEffect, useContext } from 'react';
import { Grid, Tab, Tabs, Tooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import GalleryIcon from '@material-ui/icons/ViewComfySharp';
import ListIcon from '@material-ui/icons/ListSharp';
import { ToggleButtonGroup, ToggleButton } from '@material-ui/lab';


export default function GalleryViewSelector(props) {
  const { viewMode, setViewMode } = props;

  async function handleChange(event, newValue) {
    if (newValue !== null) {
      setViewMode(newValue);
    }
  }

  return (<>
    <ToggleButtonGroup
      color='secondary'
      variant='outlined'
      value={viewMode}
      exclusive
      onChange={handleChange}
    >
      <ToggleButton value={0}>
        <Tooltip title='Grid'>
          <GalleryIcon />
        </Tooltip>
      </ToggleButton>
      <ToggleButton value={1}>
        <Tooltip title='List'>
          <ListIcon />
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>

    {/* <Tabs className={classes.tabs} value={viewMode} onChange={handleChange} orientation="vertical">
      <Tab className={classes.tab} index={0} icon={<GalleryIcon />} label="GALLERY" />
      <Tab className={classes.tab} index={1} icon={<ListIcon />} label="LIST" />
    </Tabs> */}
  </>);
}
